import { SERVICES } from 'api/common/constants';
import React from 'react';

const reportprobs = type => {
  const config = {
    farmland: {
      apiPath: '/farm/report',
      title: 'Farmland Report',
      fileName: 'FarmlandReport.xlsx',
      editPath: '/farmerReport/farmlandedit/',
      addPath: '/addCultivation/',
      editKey: 'id',
      buttons: [
        {
          enabled: false,
          buttonName: 'Add Farm',
          redirectPath: '/farmerReport/create_farm'
        }
      ],
      dateFilter: true,
      responsive: true,
      cardTittles: ['Farmland Name', 'Farmer Name', 'Total Land Holding Area'],
      service: SERVICES.DIGITIZATION
    },
    perilAlerts: {
      apiPath: '/weather/peril/alert',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Weather Peril Alerts',
      forWeather: true,
      dateFilter: false,
      district_ids: [],
      errorMsg: '"No Alerts for next 24 hours!"',
      service: SERVICES.DIGITIZATION
    },
    weatherAlertDashboard: {
      apiPath: '/weather/forcast',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Peril Alert',
      forWeather: true,
      dateFilter: false,
      globalSearch: false,
      showHeader: false,
      showFooter: false,
      service: SERVICES.DIGITIZATION
    },
    perilAlertsDashboard: {
      apiPath: '/weather/peril/alert',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Peril Alert',
      forWeather: true,
      dateFilter: false,
      globalSearch: false,
      showHeader: false,
      showFooter: false,
      limit: 3,
      errorMsg: '"No Alerts for next 24 hours!"',
      service: SERVICES.DIGITIZATION
    },
    farmerReport: {
      apiPath: '/farmer/report',
      title: 'Farmer Report',
      fileName: 'FarmerReport.xlsx',
      dateFilter: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Add Farmer',
          redirectPath: '/farmerReport/farmercreate'
        },
        {
          enabled: true,
          buttonName: 'Farmer SMS',
          redirectPath: '/farmerReport/farmersms'
        }
      ],
      editKey: 'id',
      editPath: '/farmerReport/farmeredit/',
      addPath: '/farmerReport/create_farm/',
      responsive: true,
      cardTittles: ['Farmer Name', 'Farmer ID', 'Block', 'Village'],
      service: SERVICES.DIGITIZATION
    },
    cultivationReport: {
      apiPath: '/cultivation/report',
      addPath: '/cultivation/harvest/',
      viewDetailsPath: '/cultivation/view/',
      title: 'Cultivation Report',
      editPath: '/cultivationReport/edit/',
      editKey: 'id',
      responsive: true,
      cardTittles: ['Farmer Name', 'Farm Name', 'Crop Name'],
      fileName: 'CultivationReport.xlsx',
      dateFilter: true,
      service: SERVICES.DIGITIZATION
    },
    smslogReport: {
      apiPath: '/farmer/sms/log',
      title: 'SMS Log Report',
      responsive: true,
      fileName: 'SMS Log Report.xlsx',
      dateRangePicker: true,
      service: SERVICES.DIGITIZATION
    },
    cropCalendarAlert: {
      apiPath: '/crop/calendar/alerts',
      title: 'Crop Calendar Report',
      fileName: 'CropCalendarFilterReport.xlsx',
      dropdownFilter: false,
      dateRangePicker: true,
      forInfection: false,
      service: SERVICES.DIGITIZATION
    },
    cropInfectionReport: {
      apiPath: '/crop_infection/alerts',
      title: 'Crop Infection Alerts',
      fileName: 'CropInfectionReport.xlsx',
      dropdownFilter: true,
      dateRangePicker: false,
      forInfection: true,
      service: SERVICES.DIGITIZATION
    },
    farmerGroupReport: {
      apiPath: '/farmer_group/report',
      title: 'Farmer Group Report',
      fileName: 'FarmerGroupReport.xlsx',
      dateFilter: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Add Farmer Group',
          redirectPath: '/farmerGroup'
        }
      ],
      editPath: '/farmerGroupReport/edit/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Group Name', 'Entity/Organization Name', 'Active']
    },
    cropcalendarRuleReport: {
      apiPath: '/crop/calendar/report',
      title: 'Crop Calendar Rule Report',
      fileName: 'CropCalendarRuleReport.xlsx',
      dropdownFilter: false,
      cropFilter: true,
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Crop Calendar',
          redirectPath: '/cropcalendar'
        }
      ],
      service: SERVICES.DIGITIZATION
    },
    procurementReport: {
      apiPath: '/procurement/report',
      title: 'Procurement Report',
      fileName: 'procurementReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      service: SERVICES.TRACEABILITY,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Procurement',
          redirectPath: '/procurement'
        }
      ],
      responsive: true,
      cardTittles: [
        'Procurement ID',
        'Procured On',
        'Procured From',
        'Farmer Name',
        'Procurement Farmland',
        'Procurement Status'
      ]
    },
    marketpriceReport: {
      apiPath: '/marketprice/report',
      title: 'Market Price Report',
      fileName: 'MarketPriceReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Market Price',
          redirectPath: '/marketprice'
        }
      ],
      responsive: true,
      cardTittles: ['Market/Mandi Name', 'Village', 'Approval Status'],
      service: SERVICES.DIGITIZATION
    },
    centerList: {
      apiPath: '/center/report',
      title: 'Center List',
      fileName: 'CenterList.xlsx',
      dropdownFilter: true,
      dropdownData: [
        {
          key: 'block_ids',
          label: 'Select City',
          isMulti: true,
          apiPath: '/center/block_list'
        },
        {
          key: 'center_function',
          label: 'Select Function Type',
          isMulti: true,
          apiPath: '/center/function_type'
        }
      ],
      payloadmode: 'flat',
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Center',
          redirectPath: '/processingCenter'
        }
      ],
      editPath: '/processingCenter/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Center Name', 'Center Function', 'Village']
    },
    transferReport: {
      apiPath: '/transfer/report',
      title: 'Transfer Report',
      fileName: 'TransferReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      payloadmode: 'flat',
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Transfer Items',
          redirectPath: '/transfer'
        }
      ],
      responsive: true,
      cardTittles: [
        'Transfer ID',
        'Transfer Date',
        'Transfer Type',
        'Source',
        'Destination',
        'Transfer Status'
      ]
    },
    receptionReport: {
      apiPath: '/reception/report',
      title: 'Reception Report',
      fileName: 'ReceptionReport.xlsx',
      payloadmode: 'flat',
      dateFilter: true,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Receive Stock',
          redirectPath: '/reception'
        }
      ],
      editPath: '/reception/',
      editKey: ['id'],
      responsive: true,
      cardTittles: [
        'Batch ID',
        'Reception Date',
        'Reception Center Type',
        'Reception Center',
        'StockIn Quantity'
      ]
    },
    processReport: {
      apiPath: '/process/report',
      title: 'Process Report',
      fileName: 'ProcessReport.xlsx',
      payloadmode: 'flat',
      dateFilter: true,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Process',
          redirectPath: '/process'
        }
      ],
      editPath: '/reception/',
      editKey: ['id'],
      responsive: true,
      cardTittles: [
        'process date',
        'Facility Name',
        'Input Items',
        'Process',
        'Output'
      ]
    },
    fieldOfficerReport: {
      apiPath: '/field_officer/report',
      title: 'Field Officer Report',
      fileName: 'FieldofficerReport.xlsx',
      dropdownFilter: false,
      dateRangePicker: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Field Officer',
          redirectPath: '/fieldOfficerReport/fieldOfficerCreate'
        }
      ],
      editPath: '/fieldOfficerReport/fieldOfficerEdit/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['First Name', 'Last Name']
    },
    ExportReportsPage: {
      apiPath: '/export/export_log_report',
      title: 'View All Export Data',
      responsive: true,
      cardTittles: ['Report Name', 'Action']
    }
  };

  return config[type] || {};
};

export default reportprobs;
